import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const languageDetector = {
    type: 'languageDetector',
    init: () => {},
    cacheUserLanguage: () => {},
    detect: () => {
        if (document.location.pathname.match(/\/.+\/fr.*/g)) {
            return 'fr';
        } else {
            return 'en';
        }
    },
};

i18n
    .use(Backend)
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        preload: ['en', 'fr'],
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'span', 'i', 'p', 'em', 'small', 'sup', 'ul', 'li', 'ol']
        }
    });

export default i18n;